import Section from "../../components/UI/Section/Section";
import { useHistory } from "react-router-dom";

export default () => {
  const history = useHistory();
  const handleClick = (e) => {
    e.preventDefault();
    history.goBack();
  };

  return (
    <Section>
      <a onClick={handleClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 21 19"
          width="21"
          height="19"
        >
          <path
            stroke="#FFF"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="M10.53 1 2 9.53l8.36 8.37M20.43 9.45H2"
          />
        </svg>
      </a>
    </Section>
  );
};
